const initialState = () => ({
  dyduAuth: null,
  samlEnable: false,
})

export const state = initialState()

export const mutations = {
  SET_DYDU_AUTH(state, payload) {
    state.dyduAuth = payload
  },
  RESET_DYDU_AUTH(state) {
    state.dyduAuth = null
  },
  ENABLE_SAML(state) {
    state.samlEnable = true
  },
  DISABLE_SAML(state) {
    state.samlEnable = false
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
